import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaDimeModal" */ './lazyIndex'),
    { name: 'OwaDimeModal' }
);

export const lazyLaunchDimeModal: LazyAction<typeof lazyIndex.launchDimeModal, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.launchDimeModal);

export { DimeModalEntrypoint } from './schema/DimeModalEntrypoint';
